import {useContext} from 'react';
import epicContext from './context';

const useEpicContext = () => useContext(epicContext);

export default useEpicContext;
